import { lazy } from 'react';

const AprrovedCertificationCollectivePlanConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/plan/consult/transfer',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedCertificationCollectivePlanConfig;

